import { useState, useEffect } from "react";
import { MessageCircle, X } from "lucide-react";
import { whatsappLink } from "@/data/content";

export default function Floaters() {
  const [showCookie, setShowCookie] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("fl_cookie_consent")) setShowCookie(true);
  }, []);

  const consent = (val) => {
    localStorage.setItem("fl_cookie_consent", val);
    setShowCookie(false);
  };

  return (
    <>
      <a
        data-testid="whatsapp-float-btn"
        href={whatsappLink()}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Scrivici su WhatsApp"
        className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_8px_30px_rgba(37,211,102,0.4)] hover:scale-110 transition-transform"
      >
        <MessageCircle size={26} />
      </a>

      {showCookie && (
        <div data-testid="cookie-banner" className="fixed bottom-0 inset-x-0 z-50 p-4 sm:p-5">
          <div className="mx-auto max-w-4xl rounded-2xl border border-white/10 bg-[#0b0b0b]/95 backdrop-blur-xl p-5 shadow-2xl flex flex-col sm:flex-row items-center gap-4">
            <p className="text-sm text-slate-300 flex-1">
              Utilizziamo cookie tecnici e, previo consenso, cookie di analisi e marketing (Google
              Analytics, Meta Pixel) per migliorare la tua esperienza.{" "}
              <a href="/privacy" className="text-teal-light underline">Leggi la privacy policy</a>.
            </p>
            <div className="flex gap-2 shrink-0">
              <button data-testid="cookie-reject" onClick={() => consent("rejected")} className="rounded-full border border-white/15 px-4 py-2 text-sm text-slate-200 hover:bg-white/10 transition-colors">
                Rifiuta
              </button>
              <button data-testid="cookie-accept" onClick={() => consent("accepted")} className="rounded-full bg-teal-light px-5 py-2 text-sm font-semibold text-[#050505] hover:bg-white transition-colors">
                Accetta
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
